import { Noise } from "./noise";

export interface Flatten { center: [number, number]; radius: number; falloff: number; height: number }
export interface TerrainParams {
  seed: number; octaves: number; baseFrequency: number; amplitude: number; lacunarity: number; gain: number;
  flatten: Flatten[];
}

function smoothstep(e0: number, e1: number, x: number): number {
  if (e1 <= e0) return x < e0 ? 0 : 1;
  let t = (x - e0) / (e1 - e0);
  if (t < 0) t = 0; else if (t > 1) t = 1;
  return t * t * (3 - 2 * t);
}

export function createField(p: TerrainParams): { height(x: number, z: number): number } {
  const noise = new Noise(p.seed);
  return {
    height(x, z) {
      let h = 0;
      let amp = p.amplitude;
      let freq = p.baseFrequency;
      for (let o = 0; o < p.octaves; o++) {
        h += amp * noise.eval(x * freq, z * freq);
        amp *= p.gain;
        freq *= p.lacunarity;
      }
      for (const fl of p.flatten) {
        const d = Math.hypot(x - fl.center[0], z - fl.center[1]);
        const w = 1 - smoothstep(fl.radius, fl.radius + fl.falloff, d);
        h = h * (1 - w) + fl.height * w;
      }
      return h;
    },
  };
}
